import { useCallback } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Roles } from 'constants/roles';
import { useRolePermissions } from 'hooks/useRolePermissions';

interface Props {
    label: string;
    link: string;
    roles: Roles[];
    onClose: () => void;
}
export const MainDrawerItem = ({ label, link, roles, onClose }: Props) => {
    const navigate = useNavigate();

    const goToHandler = useCallback(() => {
        navigate(link);
        onClose();
    }, [navigate, link, onClose]);

    const selectedPath = useMatch(link);

    const { hasAccess } = useRolePermissions(roles);

    if (hasAccess) {
        return (
            <ListItem key={label} disablePadding>
                <ListItemButton selected={!!selectedPath} onClick={goToHandler}>
                    <ListItemText primary={label} />
                </ListItemButton>
            </ListItem>
        );
    }

    return null;
};
